export enum TrendDirectionEnum {
  Up = 'up',
  Down = 'down',
  Stable = 'stable',
  Neutral = 'neutral',
  Warn = 'warn',
}
